import WithRender from "../../templates/ui/table.html";

export default WithRender({
  computed: {},
  props: ["tableName", "tableClass"]
});
